<div id="todo" class="page-layout carded left-sidebar">

    <!-- TOP BACKGROUND -->
    <div class="top-bg"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

    <div fxLayout="column" fxLayoutAlign="center start">
     <h1 class="titulo">{{'AUDITORIA-AUTOMATICA.TITULO' | translate}}</h1>
    </div>

<div class="content-card">
  <div class="toolbar primary px-24 py-8">
  <span><h3 class="titulo_s">{{'AUDITORIA-AUTOMATICA.TITULO' | translate}}</h3></span>
  </div>

  <mat-form-field class="instituto" appearance="outline">
    <mat-label>{{'CONSULTARENCUESTA.INSTITUTOS' | translate }}</mat-label>
    <mat-select>
      <mat-option *ngFor="let institutos of institutes" [value]="institutos.numInstituto" (click)="validarInstituto(institutos.numInstituto)">
        <!-- {{institutos.viewValue}} -->
        {{'PERFILES.EMPRESA.SECCIONES.SEC1.CATALOGOS.INSTITUTOS.'+institutos.numInstituto | translate}}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field  class="filtro" appearance="outline">
    <mat-label>{{'CONSULTARENCUESTA.FILTRO' | translate }}</mat-label>
    <input matInput (keyup)="applyFilter($event)" placeholder="{{'CONSULTARENCUESTA.SELECCIONFILTRO' | translate }}">
  </mat-form-field>
  <ng-container *ngIf="cargando">
    <div fxLayout="column" fxLayoutAlign="space-between center" >
      <mat-spinner *ngIf="false"></mat-spinner><div class="spinnerCGO"></div>
      <h1>{{'CONSULTARENCUESTA.CARGANDO' | translate }}</h1>
    </div>
  </ng-container>


  <table mat-table [dataSource]="dataSource" matSort   class="mat-elevation-z8" *ngIf="validacion && !cargando" >


    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'AUDITORIA-AUTOMATICA.TABLA.TH-NOM-EMPRESA' | translate}}</th>
      <td mat-cell *matCellDef="let element"> {{element.CompanyName}} </td>
    </ng-container>
    <ng-container matColumnDef="tipoen">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'CONSULTARENCUESTA.TIPO_ENC' | translate }}</th>
      <td mat-cell *matCellDef="let element"> {{element.ProductName}} </td>
    </ng-container>


    <ng-container matColumnDef="numcol">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'AUDITORIA-AUTOMATICA.TABLA.TH-NO-COLAB' | translate}}</th>
      <td mat-cell *matCellDef="let element"> {{element.UserTotals}} </td>
    </ng-container>


    <ng-container matColumnDef="totalco">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'AUDITORIA-AUTOMATICA.TABLA.TH-CONTESTADOS' | translate}}</th>
      <td mat-cell *matCellDef="let element"> {{element.SurveyRespondent}} </td>
    </ng-container>

    <ng-container matColumnDef="totalfa">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'AUDITORIA-AUTOMATICA.TABLA.TH-FALTANTES' | translate}}</th>
      <td mat-cell *matCellDef="let element"> {{element.UserTotals-element.SurveyRespondent}} </td>
    </ng-container>

    <ng-container matColumnDef="totalfin">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'AUDITORIA-AUTOMATICA.TABLA.TH-PROGRESO' | translate}}</th>
      <td mat-cell *matCellDef="let element"> {{(100/element.UserTotals*element.SurveyRespondent).toFixed(0)}}% </td>
    </ng-container>

    <ng-container matColumnDef="acciones">
      <th mat-header-cell *matHeaderCellDef>{{'AUDITORIA-AUTOMATICA.TABLA.TH-ACCIONES' | translate}}</th>
      <td mat-cell *matCellDef="let element">
        <ng-container >
        <button mat-mini-fab  class="mr-20" color="warn" matTooltip="{{'AUDITORIA-AUTOMATICA.TABLA.MSJ-DETALLES' | translate}}" (click)="navigateTo('auditoria/auditoriaAutomatizada/resultados-audi/',element.id_survey_configuration,element.productoId,element.token,element.CompanyName,element.productName)">
        <mat-icon>visibility</mat-icon>
        </button>
        </ng-container>
        </td>
        </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <mat-paginator [pageSizeOptions]="[25, 50, 100, 500]" showFirstLastButtons>
  </mat-paginator>
</div>
</div>
</div>
